import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/redux/hooks";
import { ShopingCart } from "../view/public/shopping/cart/shopinCart";
// import { SearchOurSite } from "../view/public/shopping/search/searchOurSite";
// import RightModalComponent from "../components/custom/customModalComponents/rightModal";
import LogoutIcon from "@mui/icons-material/Logout";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  getLocationAsync,
  setLocationVerifiedStatus,
  setUserLocation,
  setSearchText,
  setProfilesection,
} from "../../app/slices/common/locationSlice/locationSlice";
import { LoginPart } from "../view/public/loginPage/login";
// import CenterModalComponent from "../components/custom/customModalComponents/centerModal";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { IconButton, Tooltip } from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CustomDialog from "../components/custom/dialog";
import { LogoutModal } from "./components/LogoutModal";
import { LocationComponent } from "../view/public/locationSearchbar/locationComponent";
// import { showSnackbar } from "../../app/slices/common/customSnackBar/customSnackbarSlice";
import axiosInstance from "../../axios";
import { LoadingPopup } from "../view/public/locationSearchbar/LoadingPopup";
import { showSnackbar } from "../../app/slices/common/customSnackBar/customSnackbarSlice";
import { getDecryptedToken } from "../../app/auth/authHandler";
import { getPeopleBaughtListAsync } from "../../app/slices/productList/productListingSlice";
import { useMediaQuery } from "@mui/material";
function ResponsiveAppBar() {
  const isMobileScreen = useMediaQuery("(max-width:560px)");
  const hasCalled = useRef(false);
  const isModalOpened = useRef(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const locationName = useLocation();
  const [delayedOpen, setDelayedOpen] = useState(false);
  const location = useAppSelector((state) => state.locationState);
  const { addressList } = useAppSelector((state) => state?.AddressState);
  const { addTocart } = useAppSelector((state) => state.CartState);
  const cartCount = addTocart?.data?.length || 0;
  // const user: any = useAppSelector((state) => state.login);
  const [modalType, setModalType] = React.useState("");
  const [loadingModalType, setLoadingModalType] = React.useState("");

  const [selectedType, setSelectedType] = useState("");

  const [searchText, setSearch] = useState("");

  const [showLongDistancePopup, setShowLongDistancePopup] = useState(false);

  const isSearchResultsPage = locationName.pathname === "/searchResults";

  const { profileData, isValidUser, isloginNeeded }: any = useAppSelector(
    (state) => state.ProfileState,
  );
  const locationVerified = useAppSelector(
    (state) => state.locationState.locationVerified,
  );
  const { peopleBaughtList } = useAppSelector(
    (state) => state.ProductsListState,
  );
  const accessToken = getDecryptedToken();
  const aId = localStorage.getItem("aId");
  if (accessToken) {
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    delete axiosInstance.defaults.headers.common.Authorization;
  }

  useEffect(() => {
    if (!location.setLocationLoader && location.anonymous_id == null) {
      const anonymous_id = accessToken ? null : aId ? aId : null;
      callLocationFetchAPI(anonymous_id);
    }
  }, [location.setLocationLoader, location.anonymous_id]);

  useEffect(() => {
    if (location.anonymous_id) {
      const anonymous_id = accessToken ? null : location.anonymous_id;
      callLocationFetchAPI(anonymous_id);
    }
  }, [location.anonymous_id]);

  useEffect(() => {
    if (location?.locationGot?.address_id && addressList?.data?.length > 0) {
      const selected: any = addressList.data.filter(
        (item: any) => location?.locationGot?.address_id === item.id,
      )[0];
      if (selected.address_type) setSelectedType(selected?.address_type);
      else setSelectedType("");
    } else setSelectedType("");
  }, [location, addressList]);

  // useEffect(() => {
  //   if (location?.locationGot?.latitude && !hasCalled.current) {
  //     getLocationName(
  //       location?.locationGot?.latitude,
  //       location?.locationGot?.longitude
  //     );
  //     hasCalled.current = true;
  //   }
  // }, [location?.locationGot]);

  useEffect(() => {
    if (isValidUser === true) {
      const timer = setTimeout(() => {
        setDelayedOpen(true);
      }, 4000);
      return () => clearTimeout(timer);
    } else {
      setDelayedOpen(false);
    }
  }, [isValidUser]);
  const callLocationFetchAPI = (anonymous_id: string | null) => {
    dispatch(getLocationAsync(anonymous_id)).then((response: any) => {
      if (response?.payload) {
        if (response?.payload?.data?.location) {
          const location = response?.payload?.data?.location;
          // Check if long_distance flag is true
          if (response?.payload?.data?.deliverable === false) {
            setShowLongDistancePopup(true);
            return;
          }

          dispatch(setLocationVerifiedStatus("success"));
          dispatch(
            setUserLocation({
              error: null,
              display_name: location?.location_address,
              latitude: location?.latitude,
              longitude: location?.longitude,
            }),
          );
          if (peopleBaughtList?.values?.length === 0) {
            dispatch(
              getPeopleBaughtListAsync({ anonymous_id, product_id: "" }),
            );
          }
          onCloseModal();
        }
      } else {
        if (!isModalOpened.current) {
          dispatch(setLocationVerifiedStatus("failed"));
          onOpenLodingModal("loadingPopup");
          // onOpenModal("locationSearch");
          isModalOpened.current = true;
        }
      }
    });
  };

  const getLocationName = async (lat: number, lng: number) => {
    if (!window.google) {
      console.error("Google Maps API is not available.");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    const latLng = { lat, lng };

    geocoder.geocode({ location: latLng }, (results: any, status) => {
      if (status === "OK") {
        if (results[0]) {
          dispatch(
            setUserLocation({
              error: null,
              display_name: results[0]?.formatted_address || results[0]?.name,
              latitude: location?.locationGot?.latitude,
              longitude: location?.locationGot?.longitude,
            }),
          );
        } else {
          console.log("No address found.");
        }
      } else {
        console.error("Geocoder failed due to:", status);
      }
    });
  };
  const onOpenModal = (type: string) => {
    setModalType(type);
  };
  const onOpenLodingModal = (type: string) => {
    setLoadingModalType(type);
  };

  const body = document.body;
  const onCloseModal = () => {
    setLoadingModalType("");
    setModalType("");
    body.style.overflow = "auto";
    body.style.paddingRight = "0px";
    document.querySelectorAll(".offcanvas-backdrop.show").forEach((el) => {
      (el as HTMLElement).style.opacity = "0";
    });
  };
  const onCloseModal3 = () => {
    if (locationVerified === "failed") {
      // dispatch(
      //   showSnackbar({
      //     message: "Please choose location",
      //     severity: "error",
      //     autoHide: 3000,
      //   })
      // );
    }
  };

  const truncate = (text: string) => {
    return text?.length > 20 ? text.slice(0, 40) + "..." : text;
  };

  const handleLongDistancePopupClose = () => {
    setShowLongDistancePopup(false);
    onOpenLodingModal("loadingPopup");
  };

  const cleanLocationName = (text: string) => {
    // Remove leading comma and trim whitespace
    return text?.replace(/^,\s*/, "").trim();
  };
  const handleClick = () => {
    navigate("/");
  };
  const handleSearchClick = () => {
    if (searchText.trim() !== "") {
      dispatch(setSearchText(searchText));
      navigate("/searchResults");
    }
    if (isMobileScreen) {
      navigate("/searchResults");
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchClick();
    }
  };
  const handleNotificationClick = () => {
    if (isValidUser) {
      navigate("/notifications");
    } else {
      dispatch(
        showSnackbar({
          message: "Please login to see your notifications",
          severity: "error",
          autoHide: 2000,
        }),
      );
    }
  };

  return (
    <>
      <header id="header" className="header-default header-style-2">
        <div className="main-header line">
          <div className="container-full px_15 lg-px_40">
            <div className="row wrapper-header align-items-center">
              <div className="col-xl-5 tf-md-hidden">
                <div className="tf-cur">
                  <div className="col-xl-5 tf-md-hidden">
                    <div onClick={() => onOpenModal("locationSearch")}>
                      <span style={{ position: "relative" }}>
                        <span
                          style={{
                            marginRight: "5px",
                            marginTop: 3,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "250px",
                            cursor: "default",
                          }}
                        >
                          <span>
                            <LocationOnIcon style={{ marginBottom: "7px" }} />
                          </span>
                          {location?.addressSelectedtype ? (
                            <span className="address-n">
                              {location?.addressSelectedtype?.toUpperCase()} :
                            </span>
                          ) : selectedType !== "" ? (
                            <span
                              className="address-n"
                              style={{ fontWeight: "400" }}
                            >
                              {selectedType?.toUpperCase()}:
                            </span>
                          ) : (
                            ""
                          )}

                          {location?.display_name ? (
                            <span
                              style={{
                                color: "#9a9999",
                                fontSize: "14px",
                                marginLeft: 5,
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                              title={cleanLocationName(location.display_name)}
                            >
                              {truncate(
                                cleanLocationName(location.display_name),
                              )}
                            </span>
                          ) : (
                            <span
                              style={{
                                color: "#ef7d1f",
                              }}
                            >
                              Choose location
                            </span>
                          )}
                        </span>

                        <span className="icon-arrow-down kNby2"></span>
                      </span>
                    </div>
                  </div>
                  {/* <div
                    className="tf-currencies"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <span style={{ marginRight: "5px" }}>
                      <LocationOnIcon />
                    </span>
                    <div
                      style={{
                        marginRight: "5px",
                        marginTop: 3,
                        color: "#ef7d1f",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "250px",
                        cursor: "default",
                      }}
                    >
                      {location?.display_name ? (
                        <span
                          title={
                            cleanLocationName(location.display_name).length > 50
                              ? cleanLocationName(location.display_name)
                              : ""
                          }
                        >
                          {truncate(cleanLocationName(location.display_name))}
                        </span>
                      ) : (
                        "Choose location"
                      )}
                    </div>

                    <span
                      onClick={() => onOpenModal("locationSearch")}
                      style={{ marginLeft: "10px", cursor: "pointer" }}
                    >
                      <KeyboardArrowDownIcon />
                    </span>
                  </div> */}
                </div>
              </div>
              <div className="col-md-4 col-3 tf-lg-hidden">
                <a
                  href="#mobileMenu"
                  data-bs-toggle="offcanvas"
                  aria-controls="offcanvasLeft"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="16"
                    viewBox="0 0 24 16"
                    fill="none"
                  >
                    <path
                      d="M2.00056 2.28571H16.8577C17.1608 2.28571 17.4515 2.16531 17.6658 1.95098C17.8802 1.73665 18.0006 1.44596 18.0006 1.14286C18.0006 0.839753 17.8802 0.549063 17.6658 0.334735C17.4515 0.120408 17.1608 0 16.8577 0H2.00056C1.69745 0 1.40676 0.120408 1.19244 0.334735C0.978109 0.549063 0.857702 0.839753 0.857702 1.14286C0.857702 1.44596 0.978109 1.73665 1.19244 1.95098C1.40676 2.16531 1.69745 2.28571 2.00056 2.28571ZM0.857702 8C0.857702 7.6969 0.978109 7.40621 1.19244 7.19188C1.40676 6.97755 1.69745 6.85714 2.00056 6.85714H22.572C22.8751 6.85714 23.1658 6.97755 23.3801 7.19188C23.5944 7.40621 23.7148 7.6969 23.7148 8C23.7148 8.30311 23.5944 8.59379 23.3801 8.80812C23.1658 9.02245 22.8751 9.14286 22.572 9.14286H2.00056C1.69745 9.14286 1.40676 9.02245 1.19244 8.80812C0.978109 8.59379 0.857702 8.30311 0.857702 8ZM0.857702 14.8571C0.857702 14.554 0.978109 14.2633 1.19244 14.049C1.40676 13.8347 1.69745 13.7143 2.00056 13.7143H12.2863C12.5894 13.7143 12.8801 13.8347 13.0944 14.049C13.3087 14.2633 13.4291 14.554 13.4291 14.8571C13.4291 15.1602 13.3087 15.4509 13.0944 15.6653C12.8801 15.8796 12.5894 16 12.2863 16H2.00056C1.69745 16 1.40676 15.8796 1.19244 15.6653C0.978109 15.4509 0.857702 15.1602 0.857702 14.8571Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </a>
              </div>
              <div
                className={`${isMobileScreen ? "col-xl-3" : "col-xl-2"} col-md-4  col-6  d-flex align-items-center`}
                style={{
                  justifyContent: isMobileScreen ? "flex-start" : "center",
                  paddingLeft: isMobileScreen ? "0" : "",
                }}
              >
                <img
                  src="/shopnow/images/navya_logo_same_size.svg"
                  alt="NavyaToHome"
                  className="Navya"
                  onClick={handleClick}
                  style={{
                    cursor: "pointer",
                    width: "120px",
                    marginLeft: "-45px",
                  }}
                />
              </div>
              <div className="col-xl-5 col-md-4 col-3">
                <ul className="nav-icon d-flex justify-content-end align-items-center gap-20">
                  {/* commented on 12/02  */}

                  {/* <li className="nav-search">
                    <span
                      style={{ cursor: "pointer" }}
                      // onClick={() => onOpenModal("searchSite")}
                      onClick={() => navigate("/searchResults")}
                      className="nav-icon-item"
                    >
                      <i className="icon icon-search"></i>
                    </span>
                  </li> */}
                  <li>
                    {!isSearchResultsPage && (
                      <div className="search-container">
                        <input
                          className="search expandright"
                          id="searchright"
                          type="search"
                          name="q"
                          placeholder="Search"
                          value={searchText}
                          onChange={(e: any) => setSearch(e.target.value)}
                          onKeyDown={handleKeyDown}
                        />
                        <label
                          className="button searchbutton"
                          htmlFor="searchright"
                          onClick={handleSearchClick}
                        >
                          <span className="mglass">&#9906;</span>
                        </label>
                      </div>
                    )}
                  </li>
                  <li className="nav-help">
                    <a
                      title="offer"
                      className="nav-icon-item"
                      onClick={() => navigate("/offerList")}
                    >
                      <i className="icon icon-gift" title="offer"></i>
                    </a>
                  </li>
                  <li className="nav-help">
                    <a className="nav-icon-item">
                      <i
                        className="icon icon-notify"
                        onClick={handleNotificationClick}
                        title="notification"
                      ></i>
                    </a>
                  </li>
                  <li className="nav-account">
                    {isValidUser ? (
                      <Link to="/profile">
                        <span className="nav-icon-item">
                          <i className="icon icon-account"></i>
                          <span
                            style={{ marginLeft: "5px", fontWeight: "400" }}
                            className="link title ml-2"
                          >
                            {profileData?.data?.first_name
                              ? profileData?.data?.first_name
                              : profileData?.data?.phone_number}
                          </span>
                        </span>
                      </Link>
                    ) : (
                      <span
                        onClick={() => onOpenModal("login")}
                        className="nav-icon-item"
                      >
                        <i className="icon icon-account"></i>
                      </span>
                    )}
                  </li>
                  {/* commented on 12/02  */}

                  {/* <li className="nav-wishlist">
                    <a  className="nav-icon-item">
                      <i className="icon icon-heart"></i>
                      <span className="count-box">0</span>
                    </a> 
                  </li> */}
                  <li className="nav-cart">
                    <span
                      onClick={() => onOpenModal("shopingCart")}
                      className="nav-icon-item"
                    >
                      <i className="icon icon-bag"></i>
                      <span className="count-box">{cartCount}</span>
                    </span>
                  </li>
                  <li className="nav-account">
                    {isValidUser && (
                      <span className="nav-icon-item">
                        <Tooltip title="Log out">
                          <IconButton onClick={() => onOpenModal("logout")}>
                            <LogoutIcon />
                          </IconButton>
                        </Tooltip>
                      </span>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="header-bottom line tf-md-hidden">
          <div className="container-full px_15 lg-px_40">
            <div className="wrapper-header d-flex justify-content-center align-items-center">
              <nav className="box-navigation text-center">
                <ul className="box-nav-ul d-flex align-items-center justify-content-center gap-30">
                  <li className="menu-item">
                    <a href="inner.html" className="item-link">
                      Products
                    </a>
                  </li>
                  <li className="menu-item">
                    <a  className="item-link">
                      Offers
                    </a>
                  </li>
                  <li className="menu-item">
                    <a  className="item-link">
                      Orders<i className="icon icon-arrow-down"></i>
                    </a>
                  </li>
                  <li className="menu-item position-relative">
                    <a  className="item-link">
                      Help
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div> */}
      </header>
      <div className="progress-wrap">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "286.138",
            }}
          ></path>
        </svg>
      </div>
      <div className="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
        <span
          className="icon-close icon-close-popup"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></span>
        <div className="mb-canvas-content">
          <div className="mb-body">
            <ul className="nav-ul-mb" id="wrapper-menu-navigation">
              {/* <li className="nav-mb-item">
                <a  className="item-link">
                  Navya Corporate
                </a>
              </li> */}
              {/* <li className="nav-mb-item">
                <a  className="item-link">
                  Offers
                </a>
              </li> */}
              {isValidUser ? (
                <li className="nav-account nav-mb-item">
                  {/* {isValidUser ? ( */}
                  <>
                    <a
                      href="#sub-shop-two"
                      className="sub-nav-link collapsed"
                      data-bs-toggle="collapse"
                      aria-expanded="true"
                      aria-controls="sub-shop-two"
                    >
                      <div style={{ paddingTop: 10 }} className="col-6">
                        <span className="nav-icon-item">
                          <i className="icon icon-account"></i>
                          <span
                            style={{ paddingLeft: 8 }}
                            className="link title fw-6 ml-2"
                          >
                            {profileData?.data?.first_name}
                          </span>
                        </span>
                      </div>
                      <span className="btn-open-sub"></span>
                    </a>
                    <div id="sub-shop-two" className="collapse">
                      <ul className="sub-nav-menu sub-menu-level-2">
                        <li>
                          <a
                            className="sub-nav-link"
                            onClick={(e: any) => {
                              dispatch(setProfilesection("Orders"));
                              onCloseModal();
                              navigate("/profile");
                            }}
                          >
                            Orders
                          </a>
                        </li>
                        <li>
                          <a
                            className="sub-nav-link"
                            onClick={(e: any) => {
                              dispatch(setProfilesection("AccountDetails"));
                              onCloseModal();
                              navigate("/profile");
                            }}
                          >
                            Account Details
                          </a>
                        </li>
                        <li>
                          <a
                            className="sub-nav-link"
                            onClick={(e: any) => {
                              dispatch(setProfilesection("ManageAddress"));
                              onCloseModal();
                              navigate("/profile");
                            }}
                          >
                            Address
                          </a>
                        </li>
                        <li>
                          <a
                            className="sub-nav-link"
                            onClick={(e: any) => {
                              dispatch(setProfilesection("Wishlist"));
                              onCloseModal();
                              navigate("/profile");
                            }}
                          >
                            Wishlist
                          </a>
                        </li>
                        <li>
                          <a
                            className="sub-nav-link"
                            onClick={(e: any) => {
                              dispatch(setProfilesection("ReferAndEarn"));
                              onCloseModal();
                              navigate("/profile");
                            }}
                          >
                            Refer & Earn
                          </a>
                        </li>
                        <li>
                          <a
                            className="sub-nav-link"
                            onClick={(e: any) => {
                              dispatch(setProfilesection("Settings"));
                              onCloseModal();
                              navigate("/profile");
                            }}
                          >
                            Settings
                          </a>
                        </li>
                      </ul>
                    </div>
                  </>
                </li>
              ) : null}
              <li className="nav-mb-item">
                <span
                  onClick={() => onOpenModal("shopingCart")}
                  className="nav-icon-item"
                  data-bs-dismiss="offcanvas"
                >
                  My Cart
                </span>
              </li>
              {/* <li className="nav-mb-item">
                <a className="item-link">Help</a>
              </li> */}
            </ul>
            {/* <div className="mb-other-content">
              <div className="d-flex group-icon">
                <a  className="site-nav-icon">
                  <i className="icon icon-heart"></i>Wishlist
                </a>
                <a  className="site-nav-icon">
                  <i className="icon icon-search"></i>Search
                </a>
              </div>
              <div className="mb-notice">
                <a  className="text-need">
                  Need help ?
                </a>
              </div>
              <ul className="mb-info">
                <li>
                  Address: Moonnamparambu, Karukutty PO , Angamaly, Ernakulam, Kerala,
                  India-683572
                </li>
                <li>
                  Email: <b>info@navyabakers.com</b>
                </li>
                <li>
                  Phone: <b>+91 9496001256</b>
                </li>
              </ul>
            </div> */}
          </div>
          <div className="mb-bottom">
            <li className="nav-account">
              <div className="row">
                <div className="col-6"></div>
                {isValidUser ? (
                  <div className="col-6">
                    <span
                      style={{ marginLeft: 10 }}
                      onClick={() => onOpenModal("logout")}
                      className="site-nav-icon"
                      data-bs-dismiss="offcanvas"
                    >
                      <LogoutIcon />
                      Logout
                    </span>
                  </div>
                ) : (
                  <div className="col-6">
                    <span
                      onClick={() => onOpenModal("login")}
                      className="site-nav-icon"
                      data-bs-dismiss="offcanvas"
                    >
                      <i className="icon icon-account"></i>Login
                    </span>
                  </div>
                )}
              </div>
            </li>
            <div className="bottom-bar-language">
              <div
                className="tf-currencies"
                style={{ display: "flex", alignItems: "center" }}
              >
                <span style={{ marginRight: "5px" }}>
                  <LocationOnIcon style={{ marginBottom: "4px" }} />
                </span>
                <div
                  style={{
                    marginRight: "10px",
                    marginTop: 3,
                    color: "#ef7d1f",
                  }}
                >
                  {location?.addressSelectedtype ? (
                    <span className="address-n">
                      {location?.addressSelectedtype?.toUpperCase()} :
                    </span>
                  ) : selectedType !== "" ? (
                    <span className="address-n">
                      {selectedType?.toUpperCase()}:
                    </span>
                  ) : (
                    ""
                  )}

                  {location?.display_name ? (
                    <span
                      style={{
                        color: "#ef7d1f",
                        marginLeft: 5,
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                      title={
                        cleanLocationName(location.display_name).length > 50
                          ? cleanLocationName(location.display_name)
                          : ""
                      }
                    >
                      {truncate(cleanLocationName(location.display_name))}
                    </span>
                  ) : (
                    <span
                      style={{
                        color: "#ef7d1f",
                      }}
                    >
                      Choose location
                    </span>
                  )}
                </div>
                <span
                  onClick={() => onOpenModal("locationSearch")}
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  data-bs-dismiss="offcanvas"
                >
                  <KeyboardArrowDownIcon />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal modalCentered fade form-sign-in modal-part-content"
        id="login"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="header">
              <div className="demo-title">Log in</div>
              <span
                className="icon-close icon-close-popup"
                data-bs-dismiss="modal"
              ></span>
            </div>
            {/* <div className="tf-login-form">
              <LoginPart isModal={true} onClose={onCloseModal} />
            </div> */}
          </div>
        </div>
      </div>
      {/* <RightModalComponent
        openModal={modalType === "searchSite"}
        modalId="canvasSearch"
        ModalContent={SearchOurSite}
        onClose={onCloseModal}
        className={"offcanvas offcanvas-end canvas-search"}
      /> */}
      {/* <RightModalComponent
        openModal={modalType === "shopingCart"}
        modalId="shoppingCart"
        ModalContent={ShopingCart}
        onClose={onCloseModal}
        className={"modal fullRight fade modal-shopping-cart"}
      /> */}
      {/* <CenterModalComponent
        openModal={modalType === "login"}
        modalId="login"
        ModalContent={LoginPart}
        onClose={onCloseModal}
        className={"modal modalCentered fade form-sign-in modal-part-content"}
      /> */}
      <CustomDialog
        component={<LoginPart onClose={onCloseModal} />}
        title="Login"
        openDialog={modalType === "login"}
        handleCloseDialog={onCloseModal}
        modalPlace="center"
      />
      {modalType === "shopingCart" && (
        <CustomDialog
          component={<ShopingCart onClose={onCloseModal} />}
          title="Shopping Cart"
          openDialog={modalType === "shopingCart"}
          handleCloseDialog={onCloseModal}
          modalPlace="right"
        />
      )}
      <CustomDialog
        component={<LocationComponent onCloseModal={onCloseModal} />}
        title="Please Choose your Delivery Location"
        openDialog={modalType === "locationSearch"}
        handleCloseDialog={onCloseModal}
        modalPlace="left"
      />
      <CustomDialog
        component={<LogoutModal modalClose={onCloseModal} />}
        title="Logout"
        openDialog={modalType === "logout"}
        handleCloseDialog={onCloseModal}
      />
      <CustomDialog
        component={
          <div style={{ textAlign: "center", padding: "15px" }}>
            <div style={{ fontSize: "40px", marginTop: "-18px" }}>📍</div>
            <h3 style={{ color: "#333", fontSize: "18px", lineHeight: "35px" }}>
              Oops! We don't deliver to this location yet
            </h3>
            <p
              style={{
                marginTop: "5px",
                marginBottom: "20px",
                color: "#666",
                fontSize: "14px",
              }}
            >
              Please try a different address.
            </p>
            <button
              onClick={handleLongDistancePopupClose}
              style={{
                background: "#ef7d1f",
                color: "white",
                border: "none",
                padding: "10px 30px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              OK
            </button>
          </div>
        }
        title="Delivery Not Available"
        openDialog={showLongDistancePopup}
        handleCloseDialog={handleLongDistancePopupClose}
        modalPlace="center"
      />
      <CustomDialog
        component={
          <LoadingPopup
            onCloseModal={
              locationVerified === "failed" ? onCloseModal3 : onCloseModal
            }
            // onCloseModal={onCloseModal}
          />
        }
        title="loadingPopup"
        openDialog={loadingModalType === "loadingPopup"}
        handleCloseDialog={
          locationVerified === "failed" ? onCloseModal3 : onCloseModal
        }
        // handleCloseDialog={onCloseModal}
        modalPlace="center"
      />
    </>
  );
}
export default ResponsiveAppBar;
